import { type IXSLXImport } from '@principle-theorem/shared';
import type { Row } from 'exceljs';
import {
  IPatientNoteTypeToNoteXSLX,
  PATIENT_NOTE_TYPE_TO_NOTE_HEADERS,
} from './patient-note-types-to-notes-to-xlsx';

export class XSLXToPatientNoteCategoriesToNotes
  implements IXSLXImport<IPatientNoteTypeToNoteXSLX>
{
  headers = PATIENT_NOTE_TYPE_TO_NOTE_HEADERS;

  translate(row: Row): IPatientNoteTypeToNoteXSLX {
    return {
      sourceId: row.getCell('sourceId').value?.toString() ?? '',
      sourceName: row.getCell('sourceName').value?.toString() ?? '',
      mapTo: row
        .getCell('mapTo')
        .value?.toString() as IPatientNoteTypeToNoteXSLX['mapTo'],
    };
  }
}
